import { useSelector } from 'react-redux';

// Municipalities are fetched on app initialization, so just process them here
const useMunicipalityOptions = () => {
  const municipalities = useSelector(state => state.reducer.municipalities);

  const municipalityOptions = municipalities.map(municipality => ({
    value: municipality.code,
    label: municipality.name,
  }));

  return municipalityOptions;
};

export default useMunicipalityOptions;
